import styled from "@emotion/styled";
const Window = {
    Wrapper: styled.div `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.color.text};
    background-color: ${({ theme }) => theme.color.background};
    grid-row: 1/4;
    grid-column: 2/3;
  `,
    Container: styled.div `
    flex: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,
};
export default Window;
//# sourceMappingURL=Window.styled.js.map